import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';

const ShinSuMin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "이인환❤️신수민 결혼합니다.";
    const openDesc = "6월 7일 토요일 오후 12시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/193/thumb.png";

    const placeTelNum = "042-259-8010";

    const lng = 127.3832061271167;
    const lat = 36.37508307434211 ;

    const forBus = "급행3번, 121번, 705번, 911번 \n신세계백화점 앞 하차 → 호텔 오노마 입구 \n→ 호텔 5층 그랜드볼룸홀"
    const forCar = "호텔 오노마 지하주차장 이용\n※ 호텔 오노마 뒤 C 게이트로 연결됩니다.\n※ 주차는 호텔, 백화점 주차장 모두 이용 가능합니다"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#13288B",
        pointColor: "#13288B",
        btnBgColor: "#FABF2B",
        fontColor: "#ffffff",
        btnFontColor: "#313131",
        chatBgColor: "#fffbed",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Edensor"
    }


    const parents = [
        {groom : "진용성 · 서윤희의 장남"},
        {bride : "박광익 · 장남옥의 차녀"}
    ]

    const title = "결혼합니다."

    const msg1 = "@인@연이라는 이름으로 서로의 손을 잡고\n@환@하게 빛나는 미소로 서로를 마주하며\n@수@많은 시간 속에서도 언제나 같은 마음으로\n@민@들레처럼 따스한 사랑을 꽃피우겠습니다."
    const msg2 = "사랑으로 가득 찬 날,\n소중한 분들을 초대합니다."

    const groomAccountList = [
        {
            role: "신랑",
            name: "이인환",
            bank: "하나은행",
            accountNumber : "288-910218-34307",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "이병국",
            bank: "농협",
            accountNumber : "853-12-354476",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "김복경",
        //     bank: "농협은행",
        //     accountNumber : "352-4200-3349-13",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        // {
        //     role: "신부",
        //     name: "안현주",
        //     bank: "기업은행",
        //     accountNumber : "510-074547-01-011",
        //     isKakao : true,
        //     kakaoUrl : "https://qr.kakaopay.com/FM35QlLEn"
        // }
        // ,{
        //     role: "신부 부",
        //     name: "안인성",
        //     bank: "국민은행",
        //     accountNumber : "669501-04-291691",
        //     isKakao : false
        // }
        {
            role: "신부 모",
            name: "송계숙",
            bank: "하나은행",
            accountNumber : "637-315597-00108",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "정우진",
            call: "010-5467-5127"
        }
        ,
        {
            role: "신랑 부",
            name: "정창호",
            call: "010-3867-5127"
        },
        {
            role: "신랑 모",
            name: "김복경",
            call: "010-2425-3349"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "안현주",
            call: "010-2490-9377"
        }
        ,{
            role: "신부 부",
            name: "안인성",
            call: "010-2324-9377"
        }
        ,{
            role: "신부 모",
            name: "김미정",
            call: "010-7935-9377"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "🤵🏻자기소개👰🏻‍♀️ 부탁해요❤️",
            groomAnswer: "이박사에요",
            brideAnswer: "신약사에요"
        },
        {
            question : "서로의 첫인상은?💛",
            groomAnswer: "너는내운명",
            brideAnswer: "오비율좋아"
        },
        {
            question : "상대방의 매력포인트는?💙",
            groomAnswer: "똥꼬발랄함",
            brideAnswer: "은근귀여움"
        },
        {
            question : "나에게 결혼이란?🤍",
            groomAnswer: "영원한네편",
            brideAnswer: "가족이될게"
        },
        {
            question : "하객분들께 한마디🖤",
            groomAnswer: "그리웠어요",
            brideAnswer: "소랑햄수다"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FABF2B"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter pointColor={"#FABF2B"} title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper> */}
                    <div style={{height: "80px"}}/>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forBus={forBus} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default ShinSuMin;